<template>
  <div class="home-main">
    <div class="header">
      <img src="img/planejar.svg" alt="planejar" class="planejar-img">
      <!-- <img
        style="height:478px; width: 1170px"
        class="img-fluid home-img"
        src="../img/banner@2x.png"
        alt="home-img"
      /> -->
    </div>
    
    <dataPub style="display:none">1313</dataPub>
    <div style="padding:0 5vh;box-shadow: 10px 10px 56px #4E5E6D1A;flex-direction:column;" class="home-content flex-centered">
      <p align="center">Ferramenta de apoio aos profissionais contábeis e às empresas com o objetivo de auxiliar na escolha do melhor regime tributário a ser adotado pela empresa.</p>
      <br>
      <p align="center">Possibilitando a comparação entre os três regimes:</p>
      <p>- Lucro presumido;<br> - Lucro real (anual ou trimestral);<br> - Simples nacional.</p>
      <div style="flex-wrap: wrap; margin: 50px;width: 100%; display:flex; justify-content:space-around">
        <a target="_blank" href="https://www.youtube.com/watch?v=eqAnF2-4Gzc&feature=youtu.be">
      <div class="flex-centered" style="flex-direction:column">
        <p class="tutorial" style="margin:0; align-self: flex-start; font-weight:600; font-size:13px">Cálculo manual:</p>
        <img src="https://www.lefisc.com.br/planejar/img/thumb.jpg" alt="">
        <br>
      </div>
      </a>
      <a target="_blank" href="https://www.youtube.com/watch?v=X7ZMuk9KHS4">
      <div class="flex-centered" style="flex-direction:column">
        <p class="tutorial" style="margin:0; align-self: flex-start; font-weight:600; font-size:13px">Importação do ECF:</p>
        <img src="https://www.lefisc.com.br/planejar/img/thumb.jpg" alt="">
        <br>
      </div>
      </a>
      </div>
      <button :disabled="this.$store.state.user == 'lefisc'" class="start-button" @click="$router.push({name:'Simulacao', params: {select:'iniciar'}})">Iniciar Simulação</button>
      <br>
      <br>
    </div>
  </div>
</template>
<script>
import api from "../services/api"
export default {
  methods: {
  },
  computed: {},
  watch: {},
  data() {
    return {
      meses: {},
    };
  },
  async created() {

    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
  },
  mounted() {
    this.meses = this.$store.state.meses
    this.$modal.show("welcome");
  },
  updated(){
    window.scrollTo(0, 0);
  }
};
</script>

<style>
* {
  font-family: "Segoe UI";
}

input,textarea,select{width:100%;display:block}



.flex-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.header {
  height:25vw; 
  max-width: 1300px;
  background-image: url('../img/banner@2x.png');
  background-size: 100% 120%;
  background-repeat: no-repeat;
  background-color: #af3437;
  background-blend-mode: multiply;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-img {
  z-index: 1;
  position: relative;
  object-fit: cover;
}

.home-title {
  position: relative;
  font-size: 50px;
  top: 305px;
  left: 510px;
  z-index: 2;
  color: #ffffff;
}

.planejar-img {
  z-index: 3;
  width: 30%;
  position: absolute;
}

.home-content {
  align-self: center;
  background: white;
  position: relative;
  top: -70px;
  z-index: 3;
  border-radius: 10px;
  margin: 0 50px !important; 
  min-height: 500px;
}

.home-content p {
  margin: 20px 50px 0 50px;
  color: #383838;
  font-size: 18px;
  font-weight: 400;
}

.start-button {
  margin-top: 40px;
  width: 350px;
  height: 56px;
  background: #AF3437;
  color: #FFFFFF;
  font-size: 20px;
  font-style: italic;
  border-radius: 5px;
}

.start-button:hover {
  background: #943335;
}



</style>